import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer, {
  createUserSuccess,
  loginSuccess,
  logoutSuccess,
} from "../features/auth/authSlice";
import formReducer from "../features/formData/formSlice";
import mySpaceReducer from "../features/myspace/myspaceSlice";
import partnerReducer from "../features/partnerRegistration/partnerSlice";
import partnerOnboardingReducer from "../features/partnerOnboarding/partnerOnboardingSlice";
import { getAuthUser } from "../admin/navigation/adminNavigation";

const appReducer = combineReducers({
  auth: authReducer,
  form: formReducer,
  partner: partnerReducer,
  partnerOnboarding: partnerOnboardingReducer,
  mySpace: mySpaceReducer,
});

// User-scoped slices that must not leak from one account to the next.
const USER_SCOPED_SLICES = ["form", "partner", "partnerOnboarding", "mySpace"];

const userIdOf = (authState) => getAuthUser(authState)?.id ?? null;

const resetUserScopedSlices = (state) => {
  const next = { ...state };
  USER_SCOPED_SLICES.forEach((key) => {
    next[key] = undefined; // each slice falls back to its own initial state
  });
  return next;
};

/**
 * Wipes user-scoped state on logout and register, and on login when it is a different account
 * (session rehydration or a profile refresh of the same user keeps the current state).
 */
const rootReducer = (state, action) => {
  if (state) {
    if (logoutSuccess.match(action) || createUserSuccess.match(action)) {
      return appReducer(resetUserScopedSlices(state), action);
    }
    if (loginSuccess.match(action)) {
      const incomingId = getAuthUser(action.payload)?.id ?? null;
      const currentId = userIdOf(state.auth);
      if (currentId === null || incomingId === null || String(incomingId) !== String(currentId)) {
        return appReducer(resetUserScopedSlices(state), action);
      }
    }
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});
